
import Cookies from 'js-cookie';

export default {
    getU(context) {
        return new Promise((resolve, inject) => {
            let u = Cookies.get('U') || null;
            try {
                u = JSON.parse(u);
            } catch (err) {

            }
            resolve(u);
        });
    },
    getUser(context) {
        return new Promise((resolve, inject) => {
            resolve(context.state.userInfo.username);
        });
    }
};



// WEBPACK FOOTER //
// ./src/store/actions.js